// Lib
import { classicFormat } from '@/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';

// Components
import { HalfBarLineChart } from '@/components/composite/Charts/HalfBarLineChart';

export const gainedLostFollowersConfig = {
    title: 'chart.facebook.gained_lost_followers',
    tooltip: 'chart.facebook.gained_lost_followers_tooltip',
    id: 'gained_lost_followers_history',
    margin: {
        left: -25,
        right: -25,
        bottom: 25,
        top: 10
    },
    name: {
        date: 'date',
        gained: 'chart.facebook.gained_lost_followers_gained',
        lost: 'chart.facebook.gained_lost_followers_lost',
        total: 'chart.facebook.gained_lost_followers_total',
        posts: 'chart.facebook.gained_lost_followers_posts'
    },
    social: FACEBOOK,
    valueFormat: classicFormat,
    orientation: 'horizontal',
    labelLeftAxis: 'followers',
    labelRightAxis: 'chart.post_engagements.posts',
    color: {
        gained: 'green',
        lost: 'gray',
        posts: 'blue'
    },
    legendTypes: {
        gained: 'square',
        lost: 'square',
        posts: 'line'
    },
    size: SIZE_50,
    type: 'chart',
    element: HalfBarLineChart
};
